import React from "react";

export const AccessDenied = () => {
  return <div>UnAuthorized Access</div>;
};
